import { useState, useEffect } from "react";
import axios from "axios";

import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import SubHeaderPurchase from "../../../../Components/ComponentsIndustry/SubHeaderPurchase";
import ProviderCard from "../../../../Components/ComponentsIndustry/ProviderCard";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import CountFooter from "../../../../Components/ComponentsIndustry/CountFooter";
import { Supplier } from "../../../../Supplier/Supplier";
import { useRawMaterial } from "../../../../providers/RawMaterialContext";
import { useValue } from "../../../../providers/ValueContext";

import { Container, SizeContainer, TitleContent } from "./style";
import { useUser } from "../../../../providers/UserContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ToolsPurchaseCondiment = () => {
  const { insumoCondimentos, setInsumoCondimentos, getStockInsumo } = useRawMaterial();
  const history = useHistory()
  const {
    outputValue,
    setOutputValue,
    outputValueThirty,
    setOutputValueThirty,
    outputValueSixty,
    setOutputValueSixty,
    entranceValue
  } = useValue();

  let [idProvider, setIdProvider] = useState(0)

  let [providerA, setProviderA] = useState(false);
  let [inCashA, setInCashA] = useState(false);
  let [thirtyDaysA, setThirtyDaysA] = useState(false);
  let [totalA, setTotalA] = useState(0);
  let [amountA, setAmountA] = useState(0);

  let [providerB, setProviderB] = useState(false);
  let [inCashB, setInCashB] = useState(false);
  let [thirtyDaysB, setThirtyDaysB] = useState(false);
  let [sixtyDaysB, setSixtyDaysB] = useState(false);
  let [totalB, setTotalB] = useState(0);
  let [amountB, setAmountB] = useState(0);

  let [providerC, setProviderC] = useState(false);
  let [inCashC, setInCashC] = useState(false);
  let [thirtyDaysC, setThirtyDaysC] = useState(false);
  let [sixtyDaysC, setSixtyDaysC] = useState(false);
  let [totalC, setTotalC] = useState(0);
  let [amountC, setAmountC] = useState(0);

  const [message, setMessage] = useState('')

  const [sales, setSales] = useState(0);
  const [prodPlanning, setProdPlanning] = useState(0);
  const { user, rodada, industry, jogo } = useUser()
  function pagamento(data) {

    if (entranceValue > Number(data.total)) {
      axios.post("https://sistemas.sisinfor.com.br/BusinessGameBack/api/compra/cadastrar", data)
        .then(response => {
          if (response.data?.sucesso) {
            alert("Compra efetuada!")
            axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoqueInsumo/obterEstoqueIndustria/7/${industry?.industria}`)
              .then(responseEstoque => {
                var dateUpdated = insumoCondimentos
                dateUpdated.estoqueInicial = responseEstoque.data?.quantidade
                setInsumoCondimentos(dateUpdated)
              })
          } else {
            alert("Compra não pôde ser efetuada. " + response.data?.mensagem)
          }
        })
        .catch(error => console.log(error))
      // history.push("/toolsPurchaseBox")
    } else {
      alert("Saldo Insuficiente")
    }
  }

  const handlePay = () => {

    const data = {
      "fornecedor": {
        "fornecedor": idProvider
      },
      "industria": industry,
      "insumo": {
        "insumo": 7,
      },
      "pagamento": "",
      "preco": 0,
      "quantidade": 0,
      "rodada": rodada,
      "total": 0
    }

    if (providerA === true) {
      data.quantidade = parseFloat(amountA) * Number(Supplier[5].condimentos.fornecedorA.confiabilidade.replace("%", "")) / 100;
      data.preco = 60;
      data.total = parseFloat(totalA);
      if (inCashA === true) {
        data.pagamento = "avista";
        pagamento(data)
        setOutputValue(outputValue + totalA);
      } else {
        data.pagamento = "30dias";
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalA + (totalA * 5) / 100));
      }
    }

    if (providerB === true) {
      data.quantidade = amountB * Number(Supplier[5].condimentos.fornecedorB.confiabilidade.replace("%", "")) / 100;
      data.preco = 60;
      data.total = totalB;
      if (inCashB === true) {
        data.pagamento = "avista";
        pagamento(data)
        setOutputValue(outputValue + (totalB + (totalB * 2) / 100));
      } else if (thirtyDaysB === true) {
        data.pagamento = "30dias";
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalB + (totalB * 5) / 100));
      } else {
        data.pagamento = "60dias";
        pagamento(data)
        setOutputValueSixty(outputValueSixty + (totalB + (totalB * 10) / 100));
      }
    }

    if (providerC === true) {
      data.quantidade = amountC * Number(Supplier[5].condimentos.fornecedorC.confiabilidade.replace("%", "")) / 100;
      data.preco = 60;
      data.total = totalC;
      if (inCashC === true) {
        data.pagamento = "avista";
        pagamento(data)
        setOutputValue(outputValue + totalC);
      } else if (thirtyDaysC === true) {
        data.pagamento = "30dias";
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalC + (totalC * 5) / 100));
      } else {
        data.pagamento = "60dias";
        pagamento(data)
        setOutputValueSixty(outputValueSixty + (totalC + (totalC * 10) / 100));
      }
    }
    setInsumoCondimentos({
      estoqueInicial: insumoCondimentos.estoqueInicial,
      precoMedio: insumoCondimentos.precoMedio,
      cobertura: insumoCondimentos.cobertura,
      totalCompra: totalA + totalB + totalC,
      prevVenda: insumoCondimentos.prevVenda,
      quantidadeCompra:
        parseFloat(amountA) + parseFloat(amountB) + parseFloat(amountC),
    });
  };

  useEffect(() => {
    if (user && rodada) {

      getStockInsumo()

      axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/obterInsumo/${7}/${industry?.industria}/${rodada.rodada}`)
        .then(response => {
          // const data = response.data[0]

          setInsumoCondimentos({
            estoqueInicial: insumoCondimentos.estoqueInicial,
            precoMedio: insumoCondimentos.precoMedio,
            cobertura: insumoCondimentos.cobertura,
            totalCompra: insumoCondimentos.totalCompra,
            prevVenda: insumoCondimentos.prevVenda,
            prevProducao: response.data.producao ? response.data.producao : 0,
            quantidadeCompra: insumoCondimentos.quantidadeCompra,
          })

        })

    }

  }, [setInsumoCondimentos, user, rodada])

  return (
    <Container>
      <SizeContainer>
        <HeaderTools
          pathImg="./images/purchase_button.svg"
          title="Compras"
          subTitle="(Insumos e Fornecedores)"
          style={["", "selection", "", "", ""]}
        />
        <SubHeaderPurchase
          style={["", "", "", "", "", "selection", ""]}
          product="Condimentos"
          initialStock={insumoCondimentos.estoqueInicial}
          averagePrice={insumoCondimentos.estoqueInicial * insumoCondimentos.precoMedio}
          productionPlanning={insumoCondimentos.prevProducao}
          roof={insumoCondimentos.cobertura}
          sales={sales}
          setSales={setSales}
          prodPlanning={insumoCondimentos.prevProducao}
          setProdPlanning={setProdPlanning}
        />

        <TitleContent>
          <img src="./images/marketplace.svg" alt="marketplace" />
          Fornecedores de <span>Condimentos</span>
        </TitleContent>

        <ProviderCard
          setIdProvider={setIdProvider}
          Supplier={Supplier[5].condimentos}
          title1="Fornecedor A"
          minQuant1={Supplier[5].condimentos.fornecedorA.minQuant}
          precoBase1={Supplier[5].condimentos.fornecedorA.precoBase}
          leadTime1={Supplier[5].condimentos.fornecedorA.leadTime}
          atraso1={Supplier[5].condimentos.fornecedorA.atraso}
          confiabilidade1={Supplier[5].condimentos.fornecedorA.confiabilidade}
          desconto1={Supplier[5].condimentos.fornecedorA.desconto}
          provider1={providerA}
          setProvider1={setProviderA}
          inCash1={inCashA}
          setInCash1={setInCashA}
          thirtyDays1={thirtyDaysA}
          setThirtyDays1={setThirtyDaysA}
          total1={totalA}
          setTotal1={setTotalA}
          amount1={amountA}
          setAmount1={setAmountA}
          title2="Fornecedor B"
          minQuant2={Supplier[5].condimentos.fornecedorB.minQuant}
          precoBase2={Supplier[5].condimentos.fornecedorB.precoBase}
          leadTime2={Supplier[5].condimentos.fornecedorB.leadTime}
          atraso2={Supplier[5].condimentos.fornecedorB.atraso}
          confiabilidade2={Supplier[5].condimentos.fornecedorB.confiabilidade}
          desconto2={Supplier[5].condimentos.fornecedorB.desconto}
          provider2={providerB}
          setProvider2={setProviderB}
          inCash2={inCashB}
          setInCash2={setInCashB}
          thirtyDays2={thirtyDaysB}
          setThirtyDays2={setThirtyDaysB}
          sixtyDays2={sixtyDaysB}
          setSixtyDays2={setSixtyDaysB}
          total2={totalB}
          setTotal2={setTotalB}
          amount2={amountB}
          setAmount2={setAmountB}
          title3="Fornecedor C"
          minQuant3={Supplier[5].condimentos.fornecedorC.minQuant}
          precoBase3={Supplier[5].condimentos.fornecedorC.precoBase}
          leadTime3={Supplier[5].condimentos.fornecedorC.leadTime}
          atraso3={Supplier[5].condimentos.fornecedorC.atraso}
          confiabilidade3={Supplier[5].condimentos.fornecedorC.confiabilidade}
          desconto3={Supplier[5].condimentos.fornecedorC.desconto}
          provider3={providerC}
          setProvider3={setProviderC}
          inCash3={inCashC}
          setInCash3={setInCashC}
          thirtyDays3={thirtyDaysC}
          setThirtyDays3={setThirtyDaysC}
          sixtyDays3={sixtyDaysC}
          setSixtyDays3={setSixtyDaysC}
          total3={totalC}
          setTotal3={setTotalC}
          amount3={amountC}
          setAmount3={setAmountC}
          setMessage={setMessage}
        />
        <CountFooter total={totalA + totalB + totalC} />
        <FooterButton
          text="Confirmar"
          onHandle={handlePay}
        />
      </SizeContainer>
    </Container>
  );
};
export default ToolsPurchaseCondiment;
